import styled from "styled-components";
import { Container as Button } from "../../button/styles";

export const Container = styled.div`
    width: 984px;
    height: 80vh;
    padding: 6px 60px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    background: linear-gradient(
        0deg,
        #ffffff 50%,
        rgba(255, 255, 255, 0.8) 90.58%
    );
    position: relative;
    canvas {
        margin: 0 auto;
    }

    .pdf-viewer {
        max-height: 65vh !important;
    }

    button {
        &.btn-close {
            height: 40px;
            position: absolute;
            top: 32px;
            right: 32px;
            background: transparent;
            border: none;
            cursor: pointer;
        }
    }

    iframe {
        width: 100%;
        display: block;
        height: 80%;
        border: none;
    }

    ${Button} {
        width: 316px;
        margin: 0 auto;
        margin-top: auto;
        margin-bottom: 60px;
        display: block;
    }
`;
